module.exports = __webpack_public_path__ + "img/CACAO-LOGO-color-negro.ad2bcc66.svg";